import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';

import { forkJoin } from 'rxjs';

import { AlertService } from '../../services/alert.service';
import { BannerService } from '../../services/banner.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit, OnDestroy {

    currentBannersVisible: boolean = true;

    filter!: string | null;

    newBannerVisible: boolean = true;

    newBannerFormGroup!: FormGroup;

    newBannerSelectedFile!: File | null;

    currentBanners: any = {};

    adminBanners: any[] = [];

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private bannerService: BannerService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {
        this.newBannerFormGroup = this.formBuilder.group({
            newBannerFileInput: [null, Validators.required],
            newBannerNameInput: [null],
            newBannerLinkInput: [null],
            newBannerActiveCheckbox: [null],
            newBannerZeTimeCheckbox: [null],
            newBannerZeFit4Checkbox: [null],
            newBannerZeRound2Checkbox: [null],
            newBannerZeSport2Checkbox: [null]
        });
        this.refreshBanners();
    }

    ngOnDestroy() {
    }

    get banners() {
        if (this.filter == null) {
            return this.currentBanners['active'];
        } else if (['ZeTime', 'ZeFit4', 'ZeRound2', 'ZeSport2'].includes(this.filter)) {
            return this.currentBanners[this.filter];
        } else {
            return [];
        }
    }

    refreshBanners() {
        this.newBannerFormGroup.reset();
        this.newBannerSelectedFile = null;
        this.getBanners();
    }

    getBanners() {
        this.progressIndicatorService.progress = true;
        forkJoin([
            this.bannerService.getAdminBanners(),
            this.bannerService.getBanners(),
            this.bannerService.getBanners('ZeTime'),
            this.bannerService.getBanners('ZeFit4'),
            this.bannerService.getBanners('ZeRound2'),
            this.bannerService.getBanners('ZeSport2')
        ]).subscribe({
            next: ([adminBanners, activeBanners, zeTimeBanners, zeFit4Banners, zeRound2Banners, zeSport2Banners]) => {
                console.log('BannerComponent.getBanners.bannerService.getAdminBanners.value', adminBanners);
                console.log('BannerComponent.getBanners.bannerService.getBanners.value', activeBanners);
                console.log('BannerComponent.getBanners.bannerService.getBanners.ZeTime.value', zeTimeBanners);
                console.log('BannerComponent.getBanners.bannerService.getBanners.ZeFit4.value', zeFit4Banners);
                console.log('BannerComponent.getBanners.bannerService.getBanners.ZeRound2.value', zeRound2Banners);
                console.log('BannerComponent.getBanners.bannerService.getBanners.ZeRound2.value', zeSport2Banners);
                this.progressIndicatorService.progress = false;

                adminBanners.sort((a: any, b: any) => b.id - a.id);
                adminBanners.forEach((banner: any) => {
                    banner.locales.sort((a: any, b: any) => a.locale.localeCompare(b.locale));
                });

                this.adminBanners.splice(0, this.adminBanners.length);
                this.adminBanners.push(...adminBanners);

                [activeBanners, zeTimeBanners, zeFit4Banners, zeRound2Banners, zeSport2Banners].forEach(banners => {
                    banners.sort((a: any, b: any) => a.id - b.id);
                });

                this.currentBanners['active'] = activeBanners;
                this.currentBanners['ZeTime'] = zeTimeBanners;
                this.currentBanners['ZeFit4'] = zeFit4Banners;
                this.currentBanners['ZeRound2'] = zeRound2Banners;
                this.currentBanners['ZeSport2'] = zeSport2Banners;

            },
            error: (error: any) => {
                console.log('BannerComponent.getBanners.bannerService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    newBannerFileInputChange(event: any) {
        let file: File = event.target.files[0];
        this.newBannerSelectedFile = file;
    }

    uploadNewBanner() {

        let formGroup: FormGroup = this.newBannerFormGroup;

        let file: File | null = this.newBannerSelectedFile;
        if (file == null) return;

        let name: string = formGroup.value.newBannerNameInput;
        let link: string = formGroup.value.newBannerLinkInput;
        let active: boolean = formGroup.value.newBannerActiveCheckbox === true;
        let filters: string[] = [];

        if (formGroup.value.newBannerZeTimeCheckbox === true) {
            filters.push('ZeTime');
        }
        if (formGroup.value.newBannerZeFit4Checkbox === true) {
            filters.push('ZeFit4');
        }
        if (formGroup.value.newBannerZeRound2Checkbox === true) {
            filters.push('ZeRound2');
        }
        if (formGroup.value.newBannerZeSport2Checkbox === true) {
            filters.push('ZeSport2');
        }

        this.progressIndicatorService.progress = true;
        this.bannerService.uploadNewBanner(file, name, link, active, filters).subscribe({
            next: (value: any) => {
                console.log('BannerComponent.uploadNewBanner.bannerService.uploadNewBanner.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshBanners();
            },
            error: (error: any) => {
                console.log('BannerComponent.uploadNewBanner.bannerService.uploadNewBanner.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }
}
